export default class HeaderProps {
    static _defaultBreakPoint = '834px';
    static $header = document.querySelector('[data-header]');

    static get breakPoint() {
        const $root = document.querySelector(':root');
        const breakPoint = getComputedStyle($root).getPropertyValue('--breakpoint--tablet-p');
        if (breakPoint === '' || !breakPoint) {
            return HeaderProps._defaultBreakPoint;
        }
        return breakPoint;
    }
}
